import { useEffect, useState } from 'react';
import Tabs from '../../components/Tabs';
import GuestNonScriptRangeBundles from '../../components/guest/GuestNonScriptRangeBundles';
import { GuestNonScriptRangeProducts } from '../../components/guest/GuestNonScriptRangeProducts';
import { TabItem } from '../../interface/interface';
import {
  GuestCartProvider,
  useGuestCart,
} from '../../context/guestCartContext';

export default function GuestNonScriptRange() {
  const [loading, setLoading] = useState(false);
  const { addToCartMutation, removeProductFromCartMutation } = useGuestCart();

  useEffect(() => {
    if (
      !loading ||
      !addToCartMutation.isPending ||
      !removeProductFromCartMutation.isPending
    ) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [
    loading,
    addToCartMutation.isPending,
    removeProductFromCartMutation.isPending,
  ]);

  const tabs: Array<TabItem> = [
    {
      id: '1',
      label: 'Products',
      component: (
        <GuestNonScriptRangeProducts
          addToCartMutation={addToCartMutation}
          removeFromCartMutation={removeProductFromCartMutation}
          loading={loading}
        />
      ),
    },
    {
      id: '2',
      label: 'Bundles',
      component: (
        <GuestNonScriptRangeBundles
          addToCartMutation={addToCartMutation}
          removeFromCartMutation={removeProductFromCartMutation}
          loading={loading}
        />
      ),
    },
  ];

  return (
    <div className="container-standard">
      <GuestCartProvider>
        <Tabs tabs={tabs} />
      </GuestCartProvider>
    </div>
  );
}
